import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'
import {KeyOnlyFilterProvider} from '@github-ui/filter-core/providers'
import {GitBranchIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from './shared-filter-types'

export class KeyOnlyBranchFilterProvider extends KeyOnlyFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Branch',
        key: 'branch',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: GitBranchIcon,
        description: 'Filter by branch name',
      },
      {
        filterTypes: singleValueFilterTypes,
        priority: DEFAULT_FILTER_PRIORITY,
      },
    )
  }
}
